import React from 'react'
import { useForm } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button } from '../../../../../../../shadcn/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../../../../../shadcn/components/ui/dialog'
import { Icon } from '../../../../../../atoms'
import { TextArea } from '../../../../../../molecules'

interface IUserCanAskUserAdminApprovalModal {
  isOpen: boolean
  closeModal: () => void
  onSubmit: (args: { comment?: string }) => void
  isLoading: boolean
}

const UserCanAskUserAdminApprovalModal = ({
  isOpen,
  closeModal,
  onSubmit,
  isLoading,
}: IUserCanAskUserAdminApprovalModal) => {
  const intl = useIntl()
  const { control, getValues } = useForm<{
    comment?: string
  }>({
    mode: 'onBlur',
    defaultValues: {
      comment: '',
    },
  })

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && closeModal()}>
      <DialogContent backdropStyle='dark' className='lg:max-w-xl'>
        <div className='flex flex-col gap-4'>
          <DialogHeader className='mb-4 flex flex-row'>
            <DialogTitle className='flex font-medium'>
              <FormattedMessage
                id='ui.UserAskedUserAdminApprovalModal.title'
                defaultMessage='Demander l’approbation'
              />
            </DialogTitle>
            <div className='!mt-0 ml-auto flex items-center'>
              <Icon
                className='h-3 w-3'
                name='cross-without-circle'
                color='black'
                style={{ cursor: 'pointer' }}
                onClick={closeModal}
              />
            </div>
          </DialogHeader>
          <p className='text-sm'>
            <FormattedMessage
              id='ui.UserAskedUserAdminApprovalModal.userConfirmation'
              defaultMessage='Ce lieu ne correspond pas à la politique de voyage définie par votre entreprise. Pour réserver cet évènement, veuillez confirmer l’envoi d’une demande d’approbation à un administrateur de votre entreprise.'
            />
          </p>
          <div className='flex flex-col'>
            <span className='text-xs font-medium'>
              Commentaire (facultatif)
            </span>
            <TextArea
              rules={{
                required: false,
              }}
              placeholder={intl.formatMessage({
                id: 'ui.UserAskedUserAdminApprovalModal.comment.placeholder',
                defaultMessage: 'Laissez un commentaire',
              })}
              control={control}
              name='comment'
              className='text-sm font-medium'
              textAreaProps={{ className: 'p-3' }}
            />
          </div>
          <DialogFooter>
            <Button
              onClick={() => onSubmit({ comment: getValues('comment') })}
              isLoading={isLoading}
              className='text-wrap py-2'
            >
              <FormattedMessage
                id='ui.UserAskedUserAdminApprovalModal.confirm'
                defaultMessage='Envoyer la demande'
              />
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default UserCanAskUserAdminApprovalModal
